export default "__VITE_ASSET__B8FR7okf__"